/**
 * sort-persist.js — Sam's Store UAE
 * Saves the user's sort order in localStorage and restores on next page visit.
 * < 600 bytes. No dependencies.
 */
(function () {
    'use strict';

    var KEY = 'sam_sort_by';

    var sortSelect = document.querySelector('#SortBy, [data-sort-select], select[name="sort_by"]');
    if (!sortSelect) return;

    /* Restore saved value on load */
    var saved = localStorage.getItem(KEY);
    if (saved && sortSelect.querySelector('option[value="' + saved + '"]')) {
        sortSelect.value = saved;
        /* Trigger Dawn's native sort so the URL updates */
        sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Save whenever user changes */
    sortSelect.addEventListener('change', function () {
        localStorage.setItem(KEY, this.value);
    });
})();
